import { memoizedGet } from "@chakra-ui/utils";

export default function getColorCode(theme: object, color: string) {
  const hex = memoizedGet(theme, "colors." + color, color);
  return hex;
}
